import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http.service';
import { HttpParams } from '@angular/common/http';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor(private httpService: HttpService) { }

  getGenericCatalog(key: string) {
    return this.httpService.HTTP_GET(`/api/global/catalogs/generics/${key}`);
  }

  getEntitiesCatalog() {
    return this.httpService.HTTP_GET(`/api/catalogs/common/states`);
  }

  getJurisdictionsCatalog() {
    return this.httpService.HTTP_GET(`/api/catalogs/common/jurisdiction`);
  }

  getCluesCatalog(jurisdiction: string, municipality: string) {
    const params = new HttpParams()
    .set('jurisdiction', jurisdiction)
    .set('municipality', municipality);
    return this.httpService.HTTP_GET(`/api/catalogs/common/clues`, params);
  }

  getMunicipalitiesCatalog(jurisdiction: string) {
    const params = new HttpParams().set('jurisdiction', jurisdiction);
    return this.httpService.HTTP_GET(`/api/catalogs/common/municipalities`, params);
  }

  getReadSignedUrl(data: any) {
    return this.httpService.HTTP_POST(`/api/global/common/google-storage/url`,data);
  }

  getMedicationsBySearch(data: any) {
    return this.httpService.HTTP_POST(`/api/catalogs/common/medications`, data);
  }

}
